/* eslint-disable max-len */
import React, { useContext } from 'react'
import GlobalContext from '../Context/GloablContext'

export default function CardHeader({children,noPadding,classkey, body}) {
    const {isSideNavBar, swithBranch}=useContext(GlobalContext)
    return (
        /*too many boolean variables, hence didnt change the classname to 'mainDataCntnrListDiv', check and fix-Anitha*/
        <div className={`w-auto main-screen3 overflow-x-hidden ${classkey ? classkey : ''} relative ${noPadding === undefined ? 'px-4 pl-3 pt-4 mb-[10px] scrollBlue_thick stable' : 'w-full'}  ${!isSideNavBar ? ` ${body === undefined ? ' max-h-screen min-h-screen ' : ''}` : `w-[270px] ${body === undefined ? ' max-h-screen min-h-screen ' : ''}`}`}>
            <div className={`${body === undefined ? 'mainDataCntnr' : ''}`}>
                {children}
            </div>
        </div>
    )
}
